import templateUrl from './home-feature-list.html';

export const homeFeatureListComponent = {
	templateUrl,

	bindings: {
		details: '<'
	},

	controller: class HomeFeatureListComponent {
	}
};


// WEBPACK FOOTER //
// ./src/app/components/home-feature-list/home-feature-list.component.js